import * as sentry from '../../src/utils/sentry'
import { Auth_redirectReceived } from './Auth.redirect'
import { DS_setData } from '../DS/DS.Data'
import { LS_accessTokenGet, LS_accessTokenRemove } from '../LS/LS.accessToken'
import { LS_customerGet, LS_customerRemove } from '../LS/LS.customer'
import { LS_userGet, LS_userRemove } from '../LS/LS.user'
import { I18N_setLocale } from '../I18N/I18N.locale'
import { Auth_getState, Auth_setAsLoggedOut } from './Auth.State'
import { Auth_pendoIdentify, Auth_pendoInitialize } from './Auth.pendo'
import * as LaunchDarkly from '../Util/Util.launchdarkly'
import { Plat_isCordova } from '../Plat/Plat.device'
import { initWebPushNotifications } from '../WebPushNotifications'

export async function Auth_initialise() {
    // Retrieve from localStorage
    const accessToken = LS_accessTokenGet()
    const customer = LS_customerGet()
    const user = LS_userGet()
    const authState = Auth_getState()

    // Is the current page a redirect from the auth server
    // If so, the login credentials need to be extracted from the url
    const isRedirect = location.href.includes('relayState')

    Auth_pendoInitialize()

    // If we have them all, then consider us logged in
    if (user && customer && accessToken) {
        // Check if an automatic login has been requested
        if (authState.status === 'pending-automatic-login') {
            // If requested to login as other user, do not bother with old login
            if (user.email !== authState.email) return
        }

        DS_setData('LoggedInAlready', () => ({
            auth: { status: 'complete' },
            accessToken,
            customer,
            user,
        }))

        // Give the customer and user to sentry for better error reporting
        sentry.customerSet(customer.id, customer.name)
        sentry.userSet(user.id, user.email)

        Auth_pendoIdentify(customer, user)

        await LaunchDarkly.initialize({
            name: user.name,
            customerSlug: customer.slug,
            email: user.email,
            language: user.language,
            isZapticStaff: user.zapticStaff,
        })

        I18N_setLocale(user.language)

        // Handle redirects
        if (isRedirect) {
            Auth_redirectReceived(location.href)
        }

        if (!Plat_isCordova()) {
            initWebPushNotifications()
        }

        return
    } else {
        // user is not logged in
        await LaunchDarkly.initialize()
    }

    // Check if the current url is a redirect from the auth server
    // If so, the login credentials need to be extracted from the url
    if (isRedirect) {
        Auth_redirectReceived(location.href)
        if (!Plat_isCordova()) {
            initWebPushNotifications()
        }
        return
    }

    // If the accessToken's not present, but the others are, then they may have
    // been logged out due to an expired token and then closed the app
    if (!accessToken && customer && user) {
        Auth_setAsLoggedOut()
        return
    }

    // Check that these haven't got out of sync somehow
    if (accessToken || customer || user) {
        sentry.err('invalid login state', { extra: { accessToken, customer, user } })
        DS_setData('LoginInvalid', () => ({
            accessToken: null,
            customer: null,
            user: null,
        }))
        LS_accessTokenRemove()
        LS_customerRemove()
        LS_userRemove()
    }
}
